var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlogIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332.09h-9.77a2.919 2.919 0 0 0-2.92 2.92v13.484a2.412 2.412 0 0 1-2.414 2.408h15.615a2.407 2.407 0 0 0 2.407-2.408V3.01A2.919 2.919 0 0 0 18.332.09zm-4.885 13.438H9.352a.657.657 0 0 1 0-1.314h4.095a.657.657 0 0 1 0 1.314zm4.094-3.375H9.352a.657.657 0 0 1 0-1.313h8.189a.657.657 0 0 1 0 1.313zm0-3.375H9.352a.657.657 0 0 1 0-1.313h8.189a.657.657 0 0 1 0 1.313z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.329 11.32v5.174c0 .604-.49 1.094-1.095 1.094h-.007A2.408 2.408 0 0 1 .819 15.18v-.94a2.919 2.919 0 0 1 2.919-2.92h.59z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogIcon);
export default __webpack_public_path__ + "static/media/blogIcon.36677cf5c53b7eb1843acc110e1e6873.svg";
export { ForwardRef as ReactComponent };